import { useTranslation } from "react-i18next";
import singleMode from "./filterBaseSingle";

const rawItems = [
	{
		key: "aries",
		value: 0,
		meta: {
			url: "0",
			value: 0,
		},
	},
	{
		key: "taurus",
		value: 1,
		meta: {
			url: "1",
			value: 1,
		},
	},
	{
		key: "gemini",
		value: 2,
		meta: {
			url: "2",
			value: 2,
		},
	},
	{
		key: "cancer",
		value: 3,
		meta: {
			url: "3",
			value: 3,
		},
	},
	{
		key: "leo",
		value: 4,
		meta: {
			url: "4",
			value: 4,
		},
	},
	{
		key: "virgo",
		value: 5,
		meta: {
			url: "5",
			value: 5,
		},
	},
	{
		key: "libra",
		value: 6,
		meta: {
			url: "6",
			value: 6,
		},
	},
	{
		key: "scorpio",
		value: 7,
		meta: {
			url: "7",
			value: 7,
		},
	},
	{
		key: "sagittarius",
		value: 8,
		meta: {
			url: "8",
			value: 8,
		},
	},
	{
		key: "capricorn",
		value: 9,
		meta: {
			url: "9",
			value: 9,
		},
	},
	{
		key: "aquarius",
		value: 10,
		meta: {
			url: "10",
			value: 10,
		},
	},
	{
		key: "pisces",
		value: 11,
		meta: {
			url: "11",
			value: 11,
		},
	},
];

export { rawItems };

export const isValid = (value) => {
	if (value === "") {
		return true;
	}
	const validValuesArray = rawItems.map((item) => item.meta.url);
	return validValuesArray.includes(value);
};

export const compute = {
	valueToApiParam: (value) => {
		const current = rawItems.find((item) => item.value === value);
		return current ? current.value : null;
	},
	valueToUrl: (value) => {
		const current = rawItems.find((item) => item.value === value);
		return current ? current.meta.url : "";
	},
	urlToApiParam: (value) => {
		if (!value) return null;
		const current = rawItems.find(({ meta: { url } }) => url === value)
			?.meta?.value;
		return current;
	},
};

const useFilterZodiac = ({ initial }) => {
	const { t } = useTranslation(["filtersAndSelectors"]);
	const items = rawItems.map((item) => ({
		...item,
		content: t(`filtersAndSelectors:zodiac.${item.value}`),
	}));
	return {
		rawItems,
		items,
		compute,
		isValid,
		...singleMode({ items, initial, compute }),
	};
};

export default useFilterZodiac;
